export const GuardState = {
    UNLOCKED: '0',
    LOCKED: '1',
};

export const IconColor = {
    INHERIT: 'inherit',
    PRIMARY: 'primary',
    ERROR: 'error',
    ALARM: 'alarm',
    ACTIVE: 'active',
    DISABLED: 'disabled',
    FUEL_IN: 'fuelIn',
    FUEL_OUT: 'fuelOut',
};
